import {
  type BranchKey,
  useInvalidateAllConciseBranches,
} from '@festina-life/api'
import { Button } from '@festina-life/ui/actions'
import { useTranslate } from '@festina-life/ui/hooks'
import { useState } from 'react'

import { useConciseBranch } from '../../../../uiModels/branches/useConciseBranch'
import { BranchCreationWizardModal } from '../../../branchCreator/BranchCreationWizardModal'
import { getAllowedBranchCategoriesForBaseBranchCategory } from '../../../branchCreator/helpers'

type Props = {
  branchKey: BranchKey
}

export const CreateChildBranchButton = ({ branchKey }: Props) => {
  const translate = useTranslate()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const invalidate = useInvalidateAllConciseBranches()
  const conciseBaseBranch = useConciseBranch({
    server: branchKey.server,
    branchName: branchKey.name,
    shouldFallbackToStandard: false,
  })

  const handleDidCreateBranch = () => {
    setIsModalOpen(false)
    invalidate()
  }

  return (
    <>
      <BranchCreationWizardModal
        onCreate={handleDidCreateBranch}
        onCancel={() => setIsModalOpen(false)}
        isOpen={isModalOpen}
        initialValues={{
          baseBranch: conciseBaseBranch,
          category: getAllowedBranchCategoriesForBaseBranchCategory(
            conciseBaseBranch?.branchCategory,
          ).at(0),
          server: branchKey.server,
        }}
      />
      <Button startIcon="Plus" onClick={() => setIsModalOpen(true)}>
        {translate('branchDetailsPanel.tabs.manage.createBranch')}
      </Button>
    </>
  )
}
